module.exports = __webpack_public_path__ + "assets/imgs/gmp/gmp-intro.ebeeeffc5cdeeb2c4e45c675944d1b68.png";